let language = {
    BANK_TRANSFER_INTRO_INSTRUCTIONS:"Instructions:",
    BANK_TRANSFER_INTRO_STEP1_TITLE:"Make the Payment:",    
    BANK_TRANSFER_INTRO_STEP1_DES1:"Transfer the order amount of ",
    BANK_TRANSFER_INTRO_STEP1_DES2:"to our bank account (details provided above). Include your order reference number in the transfer notes.",
    BANK_TRANSFER_INTRO_STEP2_TITLE:"Confirm the Transfer:",
    BANK_TRANSFER_INTRO_STEP2_DES1:"After the transfer, enter the remittance transaction number on the ",
    BANK_TRANSFER_INTRO_STEP2_DES2:"order details ",
    BANK_TRANSFER_INTRO_STEP2_DES3:"page.  Your order will go into production after we receive the payment (usually within 1-2 days).",
    BANK_TRANSFER_INTRO_STEP3_TITLE:"Reminder:",
    BANK_TRANSFER_INTRO_STEP3_DES:"Please ensure you pay in the same currency you selected on our website. Choosing other currency may delay processing.",
    
};

export { language }